import {useNormalizer} from '@sttedra_ui/framework';

const {getString, getNumber, getBoolean, getDate, getObjectFilled} =
  useNormalizer();

function isISOString(value) {
  // ISO 8601: 2025-12-14  |  2025-12-14T00:00:00  |  2025-12-14T00:00:00Z
  const isoRegex = /^(\d{4})-(\d{2})-(\d{2})(T(\d{2}):(\d{2}):(\d{2})(\.\d{1,3})?(Z|([+-]\d{2}:\d{2}))?)?$/;
  return isoRegex.test(value);
}
export default class RegisterUserModel {
  identificationNumber;
  validDateDNI;
  supportNumber;
  name;
  surname;
  secondSurname;
  birthDate;
  countryEU;
  codIneMunicipio;
  legalRelationshipType;
  checkMinor;
  checkPrivacyPolicy;

  constructor(data) {
    this.birthDate = this.getDateTimeStamp(data?.birthDate);
    this.checkPrivacyPolicy = getBoolean(data?.checkPrivacyPolicy);
    this.checkMinor = getBoolean(data?.checkMinor);
    this.codIneMunicipio = this.getCodeIneMunicipio(data?.codIneMunicipio);
    this.countryEU = getNumber(data?.countryEU);
    this.identificationNumber = getString(data?.identificationNumber) || getString(data?.identification);
    this.legalRelationshipType = this.getTypeTutor(data?.legalRelationshipType);
    this.name = getString(data?.name);
    this.surname = getString(data?.surname);
    this.secondSurname = getString(data?.secondSurname);
    this.supportNumber = getString(data?.supportNumber);
    this.validDateDNI = this.getDateTimeStamp(data?.validDateDNI);
  }

  getTypeTutor(legalRelationshipType = {}) {
    if (!getObjectFilled(legalRelationshipType)) return null;
    return legalRelationshipType;
  }

  getCodeIneMunicipio(codIneMunicipio = {}) {
    if (!getObjectFilled(codIneMunicipio)) return null;
    return codIneMunicipio;
  }

  getDateTimeStamp(value) {
    if (value === null || value === undefined) {
      return null;
    }
    if (getString(value)) {
      if (isISOString(value)) {
        return new Date(value);
      }
      const dateComponents = value.split('/');
      const date = new Date(
        dateComponents[2],
        dateComponents[1] - 1,
        dateComponents[0],
      );
      return date;
    }

    if (getDate(value)) {
      return value;
    }

    return null;
  }
}
